// extracted by mini-css-extract-plugin
export var infoRow = "_lw-2";
export var labelContainer = "_lw-0";
export var rightInfo = "_lw-1";